// ============================================================================
// ENVIRONMENT: STAGING
// ============================================================================
export const environment = {
  // Environment flags
  production: false,
  staging: true,
  name: 'staging',

  // API Configuration
  apiUrl: 'https://api-staging.clinixcore.com.br/api',
  apiTimeout: 30000, // 30 seconds

  // Frontend URL
  frontendUrl: 'https://staging.clinixcore.com.br',

  // Google OAuth
  googleClientId: '689495053471-u7ir4r2cq4otjrdl9hq42noif4s39ar3.apps.googleusercontent.com',

  // Feature Flags
  features: {
    enableGoogleLogin: true,
    enableWhatsAppNotifications: true,
    enableEmailNotifications: true,
    enablePushNotifications: false,
    enableAdvancedReports: true,
    enableMedicalRecords: true,
    enableFinancialModule: true,
  },

  // Logging
  logging: {
    enableConsoleLog: true,
    enableErrorTracking: true,
    logLevel: 'info' as 'debug' | 'info' | 'warn' | 'error'
  },

  // Pagination
  defaultPageSize: 20,
  pageSizeOptions: [10, 20, 50, 100],

  // File Upload
  maxFileSize: 5242880, // 5MB in bytes
  allowedFileTypes: ['.pdf', '.jpg', '.jpeg', '.png', '.doc', '.docx'],

  // Session
  sessionTimeout: 3600000, // 1 hour in milliseconds
  refreshTokenBeforeExpiry: 300000, // 5 minutes

  // Password Requirements
  passwordMinLength: 6,
  passwordRequireUppercase: false,
  passwordRequireNumber: false,
  passwordRequireSpecialChar: false,

  // Appointment
  defaultAppointmentDuration: 30, // minutes
  workingHoursStart: '08:00',
  workingHoursEnd: '18:00',

  // Date/Time Format
  dateFormat: 'dd/MM/yyyy',
  timeFormat: 'HH:mm',
  dateTimeFormat: 'dd/MM/yyyy HH:mm',

  // Currency
  currency: 'BRL',
  currencySymbol: 'R$',
  locale: 'pt-BR'
};
